module.exports = __webpack_public_path__ + "img/pink.2d85e743.jpg";